"use client";

import { type ReactNode, useEffect, useLayoutEffect, useState } from "react";
import { AppWideLoader } from "./app-wide-loader";
import { useGlobalStore, getStoreContext } from "~/stores/store-provider";

interface HydrationProviderProps {
  children: ReactNode;
}

export const HydrationProvider = ({ children }: HydrationProviderProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const storeContext = getStoreContext();
  useEffect(() => {
    // Check if the store has been hydrated
    if (storeContext?.persist?.hasHydrated()) {
      setIsHydrated(true);
    }
  }, [storeContext]);

  if (!isHydrated) {
    return <AppWideLoader text="Preparing your journey..." />;
  }

  return <>{children}</>;
};
